import { Card, CardContent } from "@/components/ui/card";
import { Users, UserPlus, TrendingUp, DollarSign } from "lucide-react";

export function StatsCards({ stats, formatPrice }) {
  const cards = [
    { label: "Total Clientes",   value: stats.total_customers,            icon: Users,      color: "text-blue-600",   bg: "bg-blue-50"   },
    { label: "Nuevos (mes)",     value: stats.new_this_month,             icon: UserPlus,   color: "text-emerald-600", bg: "bg-emerald-50" },
    { label: "Ticket Medio",     value: formatPrice(stats.avg_ticket),    icon: TrendingUp, color: "text-amber-600",  bg: "bg-amber-50",  isText: true },
    { label: "Ingresos Totales", value: formatPrice(stats.total_revenue), icon: DollarSign, color: "text-teal-600",   bg: "bg-teal-50",   isText: true },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map(c => (
        <Card key={c.label} className="border-border/50" data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
          <CardContent className="p-4 flex items-center gap-4">
            <div className={`w-11 h-11 rounded-lg ${c.bg} flex items-center justify-center flex-shrink-0`}>
              <c.icon className={`w-5 h-5 ${c.color}`} />
            </div>
            <div>
              <p className="text-2xl font-bold leading-none">{c.value}</p>
              <p className="text-xs text-muted-foreground mt-1">{c.label}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
